/**
 * Local date-time formatted for use in file names, e.g. 2026-09-25-14-30-05
 * @returns {string} Timestamp string
 */
export function fileTimestamp(): string {
  return new Date().toLocaleString('sv-SE').replace(/[:\s]/g, '-');
}

/**
 * Convert rows to CSV text, quoting cells where needed
 * @param {unknown[][]} rows - Table rows
 * @returns {string} CSV content
 */
export function toCsv(rows: unknown[][]): string {
  return rows
    .map((row) =>
      row
        .map((cell) => {
          const value = cell === null || cell === undefined ? '' : String(cell);
          return /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
        })
        .join(',')
    )
    .join('\r\n');
}

/**
 * Trigger a browser download of rows as a CSV file
 * @param {unknown[][]} rows - Table rows
 * @param {string} filename - Download file name
 */
export function downloadCsv(rows: unknown[][], filename: string) {
  // BOM so Excel opens non-ASCII titles correctly; the API strips it on upload
  const blob = new Blob(['﻿' + toCsv(rows)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
